//O arquivo ENV nao funcionou de jeito nenhum, entao foi assim mesmo
module.exports = Object.freeze({
    URL_LOCAL:'https://api-indicadores.gasparimsantos.com.br',
    URL_REMOTE:'https://api-indicadores.gasparimsantos.com.br',
    URL_ANTES: 'http://10.0.20.61',
    APP_ENDPOINT:'/indicadores/v1',
    APP_PORT_LOCAL:'3337',
    APP_PORT:'',
    LOCAL_TOKEN:'md-indicador-gs',
    LOCAL_EMPRESA_SEL: 'md-indicador-gs-empresa',
    APP_TITLE:"Gasparim Santos - Indicadores",
    APP_FOOTER:"Portal do cliente"
});
